import { createClient } from "@supabase/supabase-js";
import { getCurrentTenantConfig } from "./tenantConfig";

const config = getCurrentTenantConfig();
const supabaseUrl = config.supabaseUrl;
const supabaseAnonKey = config.supabaseAnonKey;

// 前台專用 Supabase Client：獨立 storageKey，與後台 session 完全隔離
export const supabase = createClient(
  supabaseUrl || "https://mock.local",
  supabaseAnonKey || "mock-key",
  {
    auth: {
      storageKey: "frontend-auth-token",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      broadcastSession: false, // 禁用跨 tab session 廣播，防止一個 tab 被封鎖時誤傷其他前台 tab
    },
  }
);

export const isSupabaseConnected = !!(
  supabaseUrl &&
  supabaseAnonKey &&
  supabaseUrl.startsWith("https://") &&
  supabaseUrl.length > 10
);

/** Simple Supabase connection diagnostic */
export async function diagnoseConnection(): Promise<{
  connected: boolean;
  error?: string;
  sessionOk?: boolean;
}> {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.error("[diagnoseConnection] getSession error:", error);
      return { connected: false, error: error.message, sessionOk: false };
    }
    return {
      connected: true,
      sessionOk: !!data?.session,
    };
  } catch (err) {
    const msg = err instanceof Error ? err.message : "診斷失敗";
    console.error("[diagnoseConnection] 例外:", msg);
    return { connected: false, error: msg, sessionOk: false };
  }
}

/** Clear any stale Supabase session data from localStorage (frontend-only keys) */
export function clearSupabaseSessionCache() {
  try {
    // 1. 明確清除前台專用 key
    localStorage.removeItem("frontend-auth-token");

    // 2. 清除 legacy / 預設 Supabase key（只清 sb- 與 supabase. 前綴，絕不碰後台 backend-auth-token）
    const keys = Object.keys(localStorage);
    for (const key of keys) {
      if (key.startsWith("sb-") || key.startsWith("supabase.")) {
        localStorage.removeItem(key);
      }
    }
  } catch {
    // localStorage may be unavailable
  }
}